// extracted by mini-css-extract-plugin
export var wrapper = "TextAndImage-module--wrapper--UtpiQ";